<!-- Right-side drawer overlay. Clicking the scrim cancels the panel.
     Content is grouped into two compact fieldsets per round-4 feedback
     ("Identity & protocol" and "Capabilities") rather than five numbered
     steps, to reduce visual noise. -->
<div class="vct-create-scrim" (click)="cancel()" aria-hidden="true"></div>

<aside class="vct-create-drawer" role="dialog" aria-modal="true" aria-labelledby="vct-create-title"
       (click)="$event.stopPropagation()">

  <!-- ── Header ── -->
  <header class="vct-create-header">
    <div class="vct-create-title-row">
      <mat-icon class="vct-create-title-icon">add_link</mat-icon>
      <h3 class="vct-create-title" id="vct-create-title">New VM Connection Template</h3>
    </div>
    <button mat-icon-button class="vct-create-close" (click)="cancel()" matTooltip="Cancel" aria-label="Cancel">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <p class="vct-create-subtitle" *ngIf="contextLabel">{{ contextLabel }}</p>

  <mat-divider></mat-divider>

  <!-- ── Body ── -->
  <div class="vct-create-body">

    <!-- ── Group 1 — Identity & protocol ── -->
    <fieldset class="vct-group">
      <legend class="vct-group-legend">
        <mat-icon class="vct-group-icon">badge</mat-icon>
        Identity &amp; protocol
      </legend>

      <mat-form-field appearance="outline" class="vct-field">
        <mat-label>Template Name</mat-label>
        <input matInput [(ngModel)]="templateName" maxlength="100" required
               placeholder="e.g. AllowEverything" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="vct-field">
        <mat-label>Description</mat-label>
        <input matInput [(ngModel)]="description" maxlength="500"
               placeholder="Optional — what makes this configuration distinct?" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="vct-field">
        <mat-label>Default Protocol</mat-label>
        <mat-select [(ngModel)]="protocol" (selectionChange)="scheduleDuplicateCheck()">
          <mat-option *ngFor="let p of protocols" [value]="p">RDP</mat-option>
        </mat-select>
      </mat-form-field>

    </fieldset>

    <!-- ── Group 2 — Capabilities ── -->
    <fieldset class="vct-group">
      <legend class="vct-group-legend">
        <mat-icon class="vct-group-icon">tune</mat-icon>
        Capabilities
      </legend>

      <div class="vct-toggle-row">
        <mat-slide-toggle [(ngModel)]="allowCopy" (change)="scheduleDuplicateCheck()">
          <mat-icon class="vct-toggle-icon">file_copy</mat-icon>
          Allow Copy from VM
        </mat-slide-toggle>

        <mat-slide-toggle [(ngModel)]="allowPaste" (change)="scheduleDuplicateCheck()">
          <mat-icon class="vct-toggle-icon">content_paste</mat-icon>
          Allow Paste to VM
        </mat-slide-toggle>

        <mat-slide-toggle [(ngModel)]="allowFileUpload" (change)="scheduleDuplicateCheck()">
          <mat-icon class="vct-toggle-icon">folder_shared</mat-icon>
          Allow File Sharing (upload &amp; download)
        </mat-slide-toggle>

        <mat-slide-toggle [(ngModel)]="allowScreenRecording" (change)="scheduleDuplicateCheck()">
          <mat-icon class="vct-toggle-icon">ondemand_video</mat-icon>
          Allow Screen Recording
        </mat-slide-toggle>

        <mat-slide-toggle [(ngModel)]="allowAudioPlayback" (change)="scheduleDuplicateCheck()">
          <mat-icon class="vct-toggle-icon">volume_up</mat-icon>
          Allow Audio Playback
        </mat-slide-toggle>

        <mat-slide-toggle [(ngModel)]="allowBackground" (change)="scheduleDuplicateCheck()">
          <mat-icon class="vct-toggle-icon">wallpaper</mat-icon>
          Show Desktop Background (RDP wallpaper)
        </mat-slide-toggle>
      </div>
    </fieldset>

    <!-- Live duplicate banner — pre-save check using the same content hash the backend would compute -->
    <div *ngIf="duplicateExisting" class="vct-banner vct-banner-warn">
      <mat-icon>info</mat-icon>
      <div class="vct-banner-text">
        A template with identical settings already exists:
        <strong>{{ duplicateExisting.templateName }}</strong>.
        You can pick that one to avoid creating a duplicate, or change a setting to differentiate.
      </div>
      <button mat-stroked-button color="primary" (click)="pickDuplicate()">
        <mat-icon>link</mat-icon> Pick existing
      </button>
    </div>

    <!-- Inline check spinner (subtle) -->
    <div *ngIf="isCheckingDuplicate && !duplicateExisting" class="vct-banner vct-banner-info">
      <mat-progress-spinner mode="indeterminate" diameter="16"></mat-progress-spinner>
      <span>Checking for existing matching templates…</span>
    </div>

    <!-- Save error banner -->
    <div *ngIf="errorMessage" class="vct-banner vct-banner-error">
      <mat-icon>error_outline</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>

  </div>

  <mat-divider></mat-divider>

  <!-- ── Footer action bar ── -->
  <footer class="vct-create-footer">
    <button mat-button [disabled]="isSaving" (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary"
            [disabled]="isSaveDisabled"
            (click)="save()">
      <mat-spinner *ngIf="isSaving" diameter="18" class="vct-btn-spinner"></mat-spinner>
      <mat-icon *ngIf="!isSaving">check</mat-icon>
      {{ isSaving ? 'Saving…' : 'Save' }}
    </button>
  </footer>

</aside>
